export const submitCourseFeedback = async ({ BeURL, courseId, rating, description }) => {
    try {
        if (!BeURL || typeof BeURL !== 'string') {
            return {
                success: false,
                message: "Backend URL not provided or invalid"
            }
        }

        if (!courseId) {
            return {
                success: false,
                message: "Course ID not provided"
            }
        }

        if (!rating || rating < 1 || rating > 5) {
            return {
                success: false,
                message: "Rating must be between 1 and 5"
            }
        }

        if (!description || description.trim().length < 10) {
            return {
                success: false,
                message: "Feedback description must be at least 10 characters"
            }
        }

        const res = await fetch(`${BeURL}/submit-feedback`, {
            method: "POST",
            credentials: "include",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ courseId, rating, description: description.trim() })
        })

        if (!res.ok) {
            return {
                success: false,
                message: `HTTP error! status: ${res.status}`
            }
        }

        const data = await res.json()
        return data

    } catch (error) {
        console.error("Error submitting feedback:", error)
        return {
            success: false,
            message: "An error occurred while submitting feedback"
        }
    }
}
